// extracted by mini-css-extract-plugin
module.exports = {"root":"ConversationList_root__c6sbt","title":"ConversationList_title__Q4jBE","container":"ConversationList_container__ThjPq"};